import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4338CA",
      light: "#6366F1",
      dark: "#3730A3",
    },
    secondary: {
      main: "#0F766E",
      light: "#14B8A6",
      dark: "#115E59",
    },
    background: {
      default: "#f8f9fa",
      paper: "#ffffff",
    },
    text: {
      primary: "#111827",
      secondary: "#374151",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: "-0.5px",
      color: "#111827",
    },
    h2: {
      fontWeight: 700,
      letterSpacing: "-0.25px",
      color: "#111827",
    },
    h3: {
      fontWeight: 600,
      letterSpacing: "0px",
      color: "#111827",
    },
    h4: {
      fontWeight: 600,
      letterSpacing: "0.1px",
      color: "#111827",
    },
    h5: {
      fontWeight: 600,
      letterSpacing: "0.1px",
      color: "#111827",
    },
    h6: {
      fontWeight: 600,
      color: "#111827",
    },
    subtitle1: {
      fontWeight: 500,
      color: "#374151",
    },
    subtitle2: {
      fontWeight: 500,
      color: "#374151",
    },
    body1: {
      color: "#374151",
    },
    body2: {
      color: "#374151",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          padding: "10px 24px",
        },
        sizeLarge: {
          height: 48,
        },
      },
    },
  },
});
